export default __webpack_public_path__ + "static/media/template1.995a1a39.svg";